module.exports = __webpack_public_path__ + "img/answer-call-2.15e321df.png";